<template>
  <div>
    <h6
      id="muy_pronto"
      class="text-white"
    >
      {{ $t('lang.coming.coming_soon') }}
    </h6>

    <span class="text-right">{{ $t('lang.coming.date') }}</span>

    <br><br><br>

    <h5 class="text-white">
      {{ $t('lang.coming.text_1') }}
      <a href="#how">{{ $t('lang.coming.link_1') }}</a>
      {{ $t('lang.coming.text_2') }}
      <a
        :href="`/${this.$store.state.main.lang}/full-help/`"
        target="_blank"
      >{{ $t('lang.coming.link_2') }}</a>
    </h5>

    <br>
    <div
      class="alert box"
      role="alert"
    >
      {{ $t('lang.coming.msg_1') }}
      <b><a
        href="https://wekeep.hubspotpagebuilder.com/tiendas"
        target="_blank"
      >{{ $t('lang.coming.link_3') }}</a> </b>
      {{ $t('lang.coming.msg_2') }}
    </div>
    <br>
    <div>
      <div
        class="follow_us"
        align="center"
      >
        <ul>
          <li>
            <a
              href="https://www.facebook.com/app.wekeep"
              target="_blank"
            ><i class="ti-facebook" /></a>
          </li>
          <li>
            <a
              href="https://www.instagram.com/wekeep.app"
              target="_blank"
            ><i class="ti-instagram" /></a>
          </li>
          <li>
            <a
              href="https://www.linkedin.com/company/wekeep-app"
              target="_blank"
            ><i class="ti-linkedin" /></a>
          </li>
          <li>
            <a
              href="mailto:info@wekeep.app"
              target="_blank"
            ><i class="ti-email" /></a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComingSoon',

  data() {
    return {
      email: '',
    };
  },
  methods: {},

};
</script>

<style scoped>
.box {
    border-radius: 0px 20px 20px 20px;
    -moz-border-radius: 0px 20px 20px 20px;
    -webkit-border-radius: 0px 20px 20px 20px;
    border: 4px solid #4a486e;
    background-color: rgba(255, 255, 255, 0.8);
    color: #000;

}
.follow_us ul li a i {
    display: contents;
    font-size: 1.8rem;
    padding: 2rem;
    color: #fff;
}

.follow_us ul li a {
    padding: 1.3rem;
}

.follow_us ul li a:hover i {
   color: #ff1460;
}

#muy_pronto {
    border-left: 4px solid #ff1460;
    padding: 5px;
    border-bottom: 4px solid #ff1460;
}

a:hover{
    color: #4a486e;
}

a:visited{
    color: #ff1460;
}
</style>
